import React, { Component } from 'react';
import './Detailcon.css'


class Detailcon extends Component {
  render() {
    return (
      <div className="detailcon">
  
     
            <div className="card-body ">
              <i className="fas fa-map-marked-alt text-primary mb-2"></i>
              <h4 className="">Address</h4>
              <div className="detline"></div>
              <div className="">Manipal Dubai</div>
            </div>
        
        

            <div className="card-body ">
              <i className="fas fa-envelope text-primary mb-2"></i>
              <h4 className="t">Email</h4>
              <div className="detline"></div>
              <div className="s">
                <a href="1">abdullahmafuz1@gmail.com</a>
              </div>
            </div>
         
       
            <div className="card-body ">
              <i className="fas fa-mobile-alt text-primary mb-2"></i>
              <h4 className="">Phone</h4>
              <div className="detline"></div>
              <div className="">+971501234567</div>
            </div>
         
            
                <div className="dfooter " >
                  Copyright &copy; Your Website 2019
                </div>
              

     </div>
   
    );
  }
}

export default Detailcon;